import { symphonyImportErrorsForGrid } from '../../../pok/components/SymphonyImportErrors/SymphonyImportErrorsSearch';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import { DefaultApi } from '../autogenerated/pokApiClient';

export interface SymphonyImportErrorsContextInterface {
  getAllByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
  ) => Promise<GridRecord[]>;
  getAllCount: (filterText?: string, filterColumns?: string) => Promise<number>;
}

export const SymphonyImportErrorsContext = (api: DefaultApi) => {
  return {
    getAllByPortion: async (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) => {
      const data = await api.symphonyImportErrorsControllerGetAllByPortion(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
        filterColumns,
      );
      return data.map(symphonyImportErrorsForGrid);
    },
    getAllCount: (filterText?: string, filterColumns?: string) =>
      api.symphonyImportErrorsControllerGetAllCount(
        filterText || '',
        filterColumns,
      ),
  };
};
